import InsertConnector from '@/gql/connectors/InsertConnector.gql';
import { apolloClient } from './apollo';

const client_id = '04a47ba5-727a-48ca-b86e-fcb87a56e4c2';
var user = null;

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

function redirectLogin() {
  var params = new URLSearchParams({
    client_id: client_id,
    response_type: 'id_token token',
    redirect_uri: `${location.origin}/auth.html`,
    response_mode: 'fragment',
    scope: 'openid profile email offline_access Mail.Send',
    state: window.location.hash,
    nonce: 'test123',
  });
  const url = `https://login.microsoftonline.com/671ab569-f29d-4ff5-9448-cd29ac98a62e/oauth2/v2.0/authorize?${params.toString()}`;
  window.location.href = url;
}

async function ensureLoggedIn() {
  if (!localStorage.token) {
    redirectLogin();
  } else {
    var jwt = parseJwt(localStorage.token);
    if (
      (jwt.aud == client_id) // Correct audience
      &&
      ((Date.now() / 1000) < jwt.exp) // Not expired
    ) {
      // Valid JWT
      user = {
        id: jwt.email,
        first_name: jwt.given_name,
        last_name: jwt.family_name,
        name: jwt.name,
      };
      await apolloClient.mutate({
        mutation: InsertConnector,
        variables: user
      });
    } else {
      // Invalid JWT - clear token and login again
      localStorage.clear();
      redirectLogin();
    }
  }
}

function getUserId() {
  return user.id;
}
function getUser() {
  return user;
}

export default {
  ensureLoggedIn,
  getUserId,
  getUser,
}
